module.exports = __webpack_public_path__ + "img/notrhen_cyprus.871a39c.webp";